var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserprofileicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_28_1",
    "data-name": "Component 28 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.191,
    height: 97.192,
    viewBox: "0 0 97.191 97.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 48.595,
    cy: 48.595,
    rx: 48.595,
    ry: 48.595,
    fill: "#3d3e48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M191.024,546.551c-1.885-.49-3.817-.89-5.042-2.416a64.77,64.77,0,0,1-4.152-6.211,1.194,1.194,0,0,1,.261-1.128c4.016-3.134,6.389-7.418,8.492-11.909a9.406,9.406,0,0,1,1.182-1.856,10.576,10.576,0,0,0,2.382-6.832c0-1.982-.681-2.864-2.4-3.4,0-.264-.013-.538,0-.81.153-2.779.5-5.561.426-8.334a14.243,14.243,0,0,0-6.557-12.118,20.821,20.821,0,0,0-14.517-3.1c-7.351.9-15.419,5.661-15.144,16.772.063,2.542.277,5.079.422,7.629-1.623.467-2.272,1.273-2.324,3.229a10.505,10.505,0,0,0,2.285,6.862,11.448,11.448,0,0,1,1.321,2.092c1.895,4.011,4.016,7.863,7.376,10.88,1.692,1.519,1.733,1.537.616,3.549a28.817,28.817,0,0,1-2.2,3.378,8.94,8.94,0,0,1-6.032,3.653c-1.009.143-2.01.361-3,.6a56.374,56.374,0,0,0-9.276,2.927,48.583,48.583,0,0,0,57.768.043C198.963,548.84,195.021,547.592,191.024,546.551Z",
    transform: "translate(-125.464 -462.362)",
    fill: "#52535e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofileicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/user.profile.icon.b5fda1f9a70790c0454908aee213e27c.svg";
export { ForwardRef as ReactComponent };